import { render, staticRenderFns } from "./vCenter.vue?vue&type=template&id=50479ac6&"
import script from "./vCenter.vue?vue&type=script&lang=js&"
export * from "./vCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports